import { render, staticRenderFns } from "./PunchStiffness.vue?vue&type=template&id=1df792df&scoped=true&"
import script from "./PunchStiffness.vue?vue&type=script&lang=ts&"
export * from "./PunchStiffness.vue?vue&type=script&lang=ts&"
import style0 from "./PunchStiffness.vue?vue&type=style&index=0&id=1df792df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df792df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
